import { BadgeCheck, Ban, Trophy, CalendarDays, ShieldCheck, Lock } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const items = [
  { icon: BadgeCheck, title: "100 % kostenlos", text: "Keine Teilnahmegebühr, keine versteckten Kosten." },
  { icon: Ban, title: "Keine Kaufpflicht", text: "Die Teilnahme ist an keinen Kauf und keinen Vertrag gebunden." },
  { icon: Trophy, title: "Klare Preise", text: "26 echte Gewinner: 1 Hauptpreis, 20 Steuererklärungen, 5 Cashpreise." },
  { icon: CalendarDays, title: "Echte Ziehungstermine", text: "Wöchentliche Ziehungen mit festen, öffentlichen Daten." },
  { icon: ShieldCheck, title: "Schweizer Wettbewerb", text: "Klare Teilnahmebedingungen und transparente Regeln." },
  { icon: Lock, title: "Datenschutz", text: "Sichere Übertragung, keine Weitergabe ohne deine Zustimmung im Rahmen der Bedingungen." },
];

export const Trust = () => (
  <section className="bg-paper py-16 md:py-24" data-testid="trust-section">
    <div className="mx-auto max-w-[1180px] px-5">
      <Reveal>
        <h2 className="font-display text-4xl font-extrabold tracking-tight text-ink md:text-5xl">
          Vertrauen ist wichtig.
        </h2>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.06}>
            <div
              className="h-full rounded-[18px] border border-line bg-white p-6 shadow-[0_8px_24px_rgba(17,17,17,0.04)]"
              data-testid={`trust-item-${i + 1}`}
            >
              <item.icon className="h-6 w-6 text-gold-dark" strokeWidth={1.75} />
              <h3 className="mt-4 font-display text-base font-bold text-ink">{item.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-mutedlight">{item.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
